/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { Record } from 'immutable'
import AccommodationInvoiceEvent from '../../event/AccommodationInvoiceEvent'

const AccommodationInvoiceSearchState = Record({
  search_keywords: '',
  search_hotel_ids: [],
  search_start_date: null,
  search_end_date: null,
  before_invoice: false,
  invoicing: true,
  paid: false,
  uncollectible: false,
  refunded: false
})

class AccommodationInvoiceSearchStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new AccommodationInvoiceSearchState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AccommodationInvoiceEvent.onEditSearchCondition:
        return state.set(payload.name, payload.value)

      default:
        return state
    }
  }
}

export default new AccommodationInvoiceSearchStore()
